import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";

// 获取列表
export const getB2bBill = (params) => {
  return axios.request({
    url: "/finance/hq/dbl/bill",
    method: "get",
    params,
  });
};

export const getDetails = (params) => {
  return axios.request({
    url: `/finance/hq/dbl/bill/${params.id}`,
    method: "get",
    params,
  });
};

export const exportB2bBill = (id) => {
  return axios.request({
    url: `/finance/hq/dbl/bill/export/${id}`,
    method: "get",
  });
};

export const getWriteOffRecord = (id) => {
  return axios.request({
    url: `/finance/hq/dbl/bill/getWriteOffRecord/` + id,
    method: "get",
  });
};

export const exportB2bBillNew = (id) => {
  return axios.request({
    url: `/finance/hq/dbl/bill/export1/${id}`,
    method: "get",
  });
};

export const exportB2bBillFormatter = (id) => {
  return axios.request({
    url: `/finance/hq/dbl/bill/exportFormatter/${id}`,
    method: "get",
  });
};

export const addB2bBill = (data) => {
  return axios.request({
    url: `/finance/hq/dbl/bill`,
    method: "post",
    data,
  });
};

export const getB2bBillUSer = () => {
  return axios.request({
    url: `/finance/hq/dbl/bill/canCheckoutUser`,
    method: "get",
  });
};

export const updateB2bBill = (data) => {
  return axios.request({
    url: `/finance/hq/dbl/bill/${data.id}`,
    method: "put",
    data,
  });
};

export const getB2bCountryCurrency = (id) => {
  return axios.request({
    url: `/finance/hq/dbl/bill/totalAllFromCurrency/${id}`,
    method: "get",
  });
};

export const ConfirmB2bBill = (data) => {
  return axios.request({
    url: `/finance/hq/dbl/bill/pushToClient`,
    method: "post",
    data,
  });
};

export const b2bReStatistics = (data) => {
  return axios.request({
    url: `/finance/hq/dbl/bill/totalBillAmount/${data.id}`,
    method: "post",
    data,
  });
};

export const b2bWriteOff = (data) => {
  return axios.request({
    url: `/finance/hq/dbl/bill/writeOff/${data.id}`,
    method: "post",
    data,
  });
};

export const getConfig = () => {
  return axios.request({
    url: `/finance/hq/dbl/bill/config`,
    method: "get",
  });
};

export const removeDetail = (id, data) => {
  return axios.request({
    url: `/finance/hq/dbl/bill/removeDetail/${id}`,
    method: "post",
    data,
  });
};

export const delDouBill = (id) => {
  return axios.request({
    url: `/finance/hq/dbl/bill/${id}`,
    method: "delete",
  });
};

export const getB2bBillDetails = (params) => {
  return axios.request({
    url: `/finance/hq/dbl/bill/getWriteOff/${params.id}`,
    method: "get",
  });
};

export const getB2bContractHeader = (params) => {
  return axios.request({
    url: `/common/dblContractHeader`,
    method: "get",
    params,
  });
};

export const againBillAmount = (data) => {
  return axios.request({
    url: `/finance/hq/dbl/bill/againBillAmount/${data.id}`,
    method: "post",
  });
};

export const postConfirm = (id) => {
  return axios.request({
    url: `/finance/hq/dbl/bill/confirmCheck/${id}`,
    method: "post",
  });
};

export const switchRate = (data) => {
  return axios.request({
    url: `/finance/dbl/bill/switchRate/${data.id}`,
    method: "post",
    data,
  });
};


export const append = (data) => {
  return axios.request({
    url: `/finance/hq/dbl/bill/append/${data.id}`,
    method: "post",
    data,
  });
};

export const remove = (data) => {
  return axios.request({
    url: `/finance/hq/dbl/bill/remove/${data.id}`,
    method: "post",
    data,
  });
};

export const recalculate = (data) => {
  return axios.request({
    url: `/finance/hq/dbl/bill/recalculate`,
    method: "post",
    data,
  });
};

export const getBatchWriteOff = (data) => {
  return axios.request({
    url: `/finance/hq/dbl/bill/getBatchWriteOff`,
    method: "post",
    data,
  });
};

export const batchWriteOff = (data) => {
  return axios.request({
    url: `/finance/hq/dbl/bill/batchWriteOff`,
    method: "post",
    data,
  });
};


export const batchCancelConfirm = data => {
  return axios.request({
    url: `/finance/hq/dbl/bill/batchCancelConfirm`,
    method: "post",
    data
  });
}

export const previewEmail = params => {
  return axios.request({
    url: `/plugin/reviewBillEmail/dblBillEmail`,
    method: "get",
    params
  });
}

export const sendBillEmail = (id) => {
  return axios.request({
    url: `/finance/dbl/bill/sendBillEmail/${id}`,
    method: "post",
  });
};


export const adjust = data => {
  return axios.request({
    url: `/finance/statement/adjust/writeOff`,
    method: "post",
    data
  });
}

export const getWaitOffData = data => {
  return axios.request({
    url: `/finance/statement/adjust/getWaitOffData`,
    method: "post",
    data
  });
}

export function upload(data) {
  return axios.request({
    url: `/finance/statement/adjust/upload`,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken()
    },
    data: data
  });
}
